/**
 * PhaseSplash - Kurzer Splash-Screen bei Phasenwechsel
 *
 * Zeigt Badge mit Rundennummer und Phasentext.
 * Automatische Ausblendung nach konfigurierter Dauer.
 */

import React, { useEffect, useCallback } from 'react';
import { SPLASHES } from '../../config/animationTimings';
import './PhaseSplash.css';

// Phase-spezifische Konfiguration (Dauer aus zentraler Config)
const PHASE_CONFIG = {
  shop: {
    text: 'Shoppen!',
    icon: '🛒',
  },
  cardCount: {
    text: 'Karten austeilen!',
    icon: '🃏',
  },
  sealDistribution: {
    text: 'Siegel vergeben!',
    icon: '🔮',
  },
  exchanging: {
    text: 'Karten tauschen!',
    icon: '🔄',
  },
  playing: {
    text: "Los geht's!",
    icon: '🎮',
  },
  // roundEnd: kein Splash - wird in RoundEndOverlay behandelt
};

export function PhaseSplash({ phase, partieNumber, onComplete }) {
  const config = PHASE_CONFIG[phase];

  // Auto-dismiss after duration (from central config)
  useEffect(() => {
    if (!config) {
      onComplete?.();
      return;
    }

    const timer = setTimeout(() => {
      onComplete?.();
    }, SPLASHES.phaseDuration);

    return () => clearTimeout(timer);
  }, [phase, config, onComplete]);

  // Allow click to dismiss early
  const handleClick = useCallback(() => {
    onComplete?.();
  }, [onComplete]);

  // Don't render if no config for this phase
  if (!config) return null;

  return (
    <div className="phase-splash" onClick={handleClick}>
      <div className="phase-splash-content">
        <div className="phase-splash-badge">
          Partie {partieNumber}
        </div>
        <div className="phase-splash-text">
          <span className="phase-splash-icon">{config.icon}</span>
          <span className="phase-splash-label">{config.text}</span>
        </div>
      </div>
    </div>
  );
}

export default PhaseSplash;
